import * as yup from "yup";

import dayjs from "dayjs";

import { FORM_FIELDS } from "@constants/form";

export const ROOM_CONFERENCE = FORM_FIELDS.INVENTORY.ROOM_CONFERENCE;

export const roomConferenceValidationSchema = yup.object().shape({
  [ROOM_CONFERENCE.OFFICE]: yup.string().required("Office is required"),

  [ROOM_CONFERENCE.BUILDING]: yup.string().required("Building is required"),

  [ROOM_CONFERENCE.ROOM]: yup.string().required("Room is required"),

  [ROOM_CONFERENCE.MEETING_PURPOSE]: yup
    .string()
    .required("Meeting purpose is required"),

  [ROOM_CONFERENCE.TOTAL_ATTENDEES]: yup
    .string()
    .required("Total attendees is required"),

  [ROOM_CONFERENCE.BOOKING_START_DATE]: yup
    .string()
    .required("Meeting start date is required"),

  [ROOM_CONFERENCE.BOOKING_END_DATE]: yup
    .string()
    .required("Meeting end date is required")
    .test({
      name: `is-${ROOM_CONFERENCE.BOOKING_END_DATE}`,
      skipAbsent: true,
      test(value, schema) {
        const startDateTime = schema.parent.bookingStartDate || "";
        const endDateTime = schema.parent.bookingEndDate || "";

        const isAfter = dayjs(endDateTime).isAfter(startDateTime, "minute");

        if (!isAfter) {
          return schema.createError({
            message: "End time must greater then Start time",
          });
        } else {
          return true;
        }
      },
    }),

  [ROOM_CONFERENCE.DOCUMENT]: yup
    .object()
    .required()
    .shape({
      id: yup.number(),
      name: yup.string(),
      mimeType: yup.string(),
      fileId: yup.string(),
      documentId: yup.string(),
      documentType: yup.string(),
    })
    .nullable(),
});

export type RoomConferenceSchemaType = yup.InferType<
  typeof roomConferenceValidationSchema
>;
